import { useCallback, useState } from 'react';
import { ServiceClient } from '../../../Services/ServiceClient';
import { useDebouncedEffect } from '../../../Helpers/CustomHooks';

export const useAgentSearch = (query, setIsLoading, coAgentCode) => {
  const [agents, setAgents] = useState([]);

  const findAgents = useCallback(() => {
    if (!query || query.trim().length === 0 || query === coAgentCode) {
      setAgents([]);
      return;
    }
    setIsLoading(true);
    ServiceClient.findAgents(
      query,
      data => {
        if (data?.length > 0) {
          setIsLoading(false);
          setAgents(data);
        } else {
          setIsLoading(false);
          setAgents([]);
        }
      },
      () => {
        setIsLoading(false);
        setAgents([]);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useDebouncedEffect(findAgents, 500);

  return agents;
};
